import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Chart from 'react-apexcharts';
import CheckBoxAsToggle from '@lib/components/CheckBoxAsToggle/CheckBoxAsToggle';
import WhiteBox from '@lib/components/WhiteBox/WhiteBox';
import buildCategoriesPieData from '../utils/buildCategoriesPieData';
import { CategoryAnalyticsRow } from '../utils/getCategoryTableColumns';
import styles from './CategoriesPie.module.scss';

interface Props {
  rows: CategoryAnalyticsRow[];
}

export default function CategoriesPie({ rows }: Props) {
  const { t, i18n } = useTranslation();
  const [useRealColors, setUseRealColors] = useState(false);

  const { options, series } = useMemo(
    () =>
      buildCategoriesPieData({
        rows,
        useRealColors,
        locale: i18n.language,
        t,
      }),
    [rows, useRealColors, i18n.language, t],
  );

  return (
    <div className={styles.root}>
      <div className={styles.toggleWrap}>
        <WhiteBox verticalPaddings="small" horizontalPaddings="small">
          <CheckBoxAsToggle
            id="real-category-colors-toggle"
            name="real-category-colors"
            checked={useRealColors}
            onChange={() => setUseRealColors((v) => !v)}
            label={t('real-category-colors')}
          />
        </WhiteBox>
      </div>
      <div className={styles.chartWrap}>
        <Chart
          key={`${useRealColors}-${rows.length}`}
          options={options}
          series={series}
          type="donut"
          width="100%"
          height="350px"
        />
      </div>
    </div>
  );
}
